export default __webpack_public_path__ + "static/media/OurBloggers1.0731bdfa.png";